import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { BodyCopy } from 'secondstep-components'

export const ImgAndTextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.875rem;
`

export const InfoText = styled(BodyCopy)`
  color: ${themeGet('colors.darkGray')};
`

export const IntroWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 1.625rem;
  margin-bottom: 2.5rem;
`
export const PurposeImg = styled.img`
  width: 53%;
  padding-right: 1.25rem;
`
